/** @file checkClip: validates one clip of the draft after a command, with paths under `/clips/<name>`. */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import { validateClip } from '@zilo/pose3d-format/validate/validateClip';
import { withPathPrefix } from '../validate/withPathPrefix';

/** Throws the first error of `clip` (rolling the batch back). */
export function checkClip(name: string, clip: Clip): void {
  withPathPrefix(`/clips/${name}`, () => validateClip(clip));
}
